module.exports = __webpack_public_path__ + "img/BASEBALL CAP BN.e866925.svg";